window.addEventListener('alpine:init', () => {
  function lottieAnimation(data = {}) {
    return {
      ...data,

      init() {
        this.onLottiewebloaded = this.onLottiewebloaded.bind(this);

        window.addEventListener('lottiewebloaded', this.onLottiewebloaded, { once: true });

        if (window.global.isLottieWebLoaded) {
          this.loadAnimation();
        }
      },

      destroy() {
        window.removeEventListener('lottiewebloaded', this.onLottiewebloaded);
      },

      onLottiewebloaded() {
        this.loadAnimation();
      },

      onIntersect() {
        if (window.global.isLottieWebLoading) return;

        window.global.isLottieWebLoading = true;

        this.$store.utilities.getScript(window.global.asset_url['js-vendor-lottie-web@5.13.0.js'], () => {
          window.global.isLottieWebLoaded = true;

          dispatchEvent(new CustomEvent('lottiewebloaded'));
        });
      },

      loadAnimation() {
        lottie.loadAnimation({
          container: this.$el,
          renderer: 'canvas',
          path: this.url
        });
      }
    };
  };

  Alpine.data('lottieAnimation', lottieAnimation);
});
